import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import Toggle from 'components/Toggle';

import { Container, Content, Header, Switch } from './styles';

interface Props {
  cabinName: string;
  cabinValue: string;
  isActive: boolean;
  type: 'domestic' | 'international';
  onToggle?: (cabinValue: string, type: 'domestic' | 'international') => void;
}

const GroupCabinItem = ({ cabinName, cabinValue, isActive, onToggle, type }: Props) => {
  const theme = useTheme() as ThemeType;

  const useStyles = makeStyles(() => ({
    switch_track: {},
    switch_base: {
      color: '#f50057',
      '&.Mui-disabled': {
        color: 'Red',
      },
      '&.Mui-checked': {
        color: 'Pink',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.secondaryBackgroundColor,
      },
    },
    switch_primary: {
      '&.Mui-checked': {
        color: '#4CAF50',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#4CAF50',
      },
    },
  }));
  return (
    <Container>
      <Content>
        <Switch>
          <Toggle
            onChange={() => {
              onToggle(cabinValue, type);
            }}
            checked={isActive}
            classes={{
              track: useStyles().switch_track,
              switchBase: useStyles().switch_base,
              colorPrimary: useStyles().switch_primary,
            }}
          />
        </Switch>
        <Header>
          <Header.Title>{cabinName}</Header.Title>
        </Header>
      </Content>
    </Container>
  );
};

export default GroupCabinItem;
